import { createFileRoute } from '@tanstack/react-router'
import { EmailConfirmPage } from '../components/email-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/conferma')({
  head: () => noIndexRouteHead('emailConfirm', 'it'),
  component: EmailConfirmPage,
})
